var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyKlosetIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 41,
    viewBox: "0 0 61 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_1361",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.102539H52.7585V34.5353H0V0.102539Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4807 0.109131H3.19453C1.43357 0.109131 0 1.54076 0 3.30883V31.3034C0 33.0676 1.42582 34.5031 3.1984 34.4992H38.5617C37.9514 33.0159 37.6085 31.3899 37.6085 29.6865C37.6085 22.6956 43.2679 17.0278 50.2491 17.0278C51.0802 17.0278 51.8861 17.1137 52.672 17.2661V3.30495C52.6752 1.54464 51.2455 0.109131 49.4807 0.109131ZM4.99617 8.64467C4.99617 7.97631 5.53925 7.43647 6.20308 7.43647H16.7618C17.4288 7.43647 17.9719 7.97631 17.9719 8.64467V15.0324C17.9719 15.7008 17.4288 16.2413 16.7618 16.2413H6.20696C5.53925 16.2413 4.99617 15.7008 4.99617 15.0324V8.64467ZM4.99617 23.5073H24.3429V25.6111H4.99617V23.5073ZM15.2978 29.7401H4.99617V27.6323H15.2978V29.7401ZM35.0423 29.7401H19.2414V27.6323H35.0423V29.7401ZM35.0423 25.6092H28.3304V23.5053H35.0423V25.6092ZM42.3018 16.5351C41.2816 16.5351 40.3401 16.1993 39.5677 15.6433C38.8019 16.1916 37.8694 16.5196 36.8575 16.5196C34.2706 16.5196 32.1778 14.4235 32.1778 11.8405C32.1778 9.25361 34.2706 7.15363 36.8575 7.15363C37.8694 7.15363 38.8019 7.48619 39.5677 8.03766C40.3381 7.47844 41.2796 7.142 42.3018 7.142C44.8881 7.142 46.9926 9.24973 46.9926 11.8405C46.9926 14.4274 44.89 16.5351 42.3018 16.5351Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_159_1361",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 18,
    width: 22,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3682 18.8306H61.0002V40.3974H39.3682V18.8306Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_159_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2468 18.9139C44.3085 18.9139 39.4893 23.7338 39.4893 29.6864C39.4893 35.6337 44.3066 40.4555 50.2468 40.4555C56.1864 40.4555 60.9999 35.6318 60.9999 29.6844C60.9999 23.7338 56.1864 18.9139 50.2468 18.9139ZM55.407 34.9098C55.407 35.3567 55.0428 35.7196 54.5985 35.7196H45.8867C45.4444 35.7196 45.0828 35.3586 45.0828 34.9098V28.5221C45.0828 28.0713 45.4431 27.7091 45.8867 27.7091H45.9539C46.1101 24.5914 47.5398 22.9951 50.2468 22.9951C52.9493 22.9951 54.3829 24.5914 54.5359 27.7091H54.5985C55.0409 27.7091 55.407 28.0694 55.407 28.5221V34.9098Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyKlosetIcon1);
export default __webpack_public_path__ + "static/media/whyKlosetIcon1.d8a3868c9e824649f6992276d676f633.svg";
export { ForwardRef as ReactComponent };